<div class="container">
  <h1 class="section-title">
    {{ isEditMode ? 'Edit Licensed Product' : 'Create Licensed Product' }}
  </h1>

  <div class="loading" *ngIf="loading">Loading licensed product...</div>

  <ng-container *ngIf="loadFailed">
    <app-response-banner
      [success]="false"
      [errorMessage]="errorMessage"
      [invisible]="false"
    ></app-response-banner>
    <div class="button-box half-width">
      <app-button [title]="'Back'" (click)="cancel()"></app-button>
    </div>
  </ng-container>

  <form
    *ngIf="!loading && !loadFailed"
    [formGroup]="form"
    [noValidate]="true"
    (ngSubmit)="submit()"
  >
    <h2 class="section-sub-title">Product Details</h2>

    <div class="form-column half-width">
      <mat-form-field appearance="outline">
        <mat-label>Product Name</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          formControlName="name"
          placeholder="Enter product name"
        />
        <mat-error *ngIf="nameControl.hasError('required')">
          Product name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>License Target</mat-label>
        <mat-select formControlName="target">
          <mat-option value="DEVICE">Device</mat-option>
          <mat-option value="USER">User</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['target'].hasError('required')">
          License target is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          class="input-filed"
          matInput
          formControlName="description"
          placeholder="Enter product description"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <h2 class="section-sub-title">Licensed Components</h2>
    <div class="component-empty-state" *ngIf="componentsLoading()">
      Loading components...
    </div>

    <div
      class="component-empty-state"
      *ngIf="!componentsLoading() && componentsLoadError()"
    >
      Failed to load components.
    </div>

    <div
      class="component-section"
      *ngIf="!componentsLoading() && availableComponents.length > 0"
    >
      <mat-form-field appearance="outline" class="component-search">
        <mat-label>Search Components</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="text"
          placeholder="Search by component name"
          [formControl]="componentSearchControl"
          (input)="resetAvailableComponentsPagination()"
          (keydown.enter)="$event.preventDefault()"
        />
      </mat-form-field>

      <div class="component-group">
        <h3 class="component-group-title">
          Selected Components ({{
            formatComponentCount(
              selectedComponentCards.length,
              allSelectedComponentCards.length
            )
          }})
        </h3>
        <div class="component-card-grid">
          <app-license-component-card
            *ngFor="
              let component of selectedComponentCards;
              trackBy: trackByComponentId
            "
            [component]="component"
            [displayName]="component.componentName"
            [selected]="true"
            (toggle)="onComponentCardToggle($event)"
          ></app-license-component-card>
        </div>
        <p
          class="component-hidden-note"
          *ngIf="hiddenSelectedComponentCount > 0"
        >
          {{ hiddenSelectedComponentsMessage }}
        </p>
      </div>

      <div class="component-group">
        <h3 class="component-group-title">
          Available Components ({{
            formatComponentCount(
              unselectedComponentCards.length,
              allUnselectedComponentCards.length
            )
          }})
        </h3>
        <div class="component-card-grid">
          <app-license-component-card
            *ngFor="
              let component of paginatedUnselectedComponentCards;
              trackBy: trackByComponentId
            "
            [component]="component"
            [displayName]="component.componentName"
            [selected]="false"
            (toggle)="onComponentCardToggle($event)"
          ></app-license-component-card>
        </div>

        <mat-paginator
          *ngIf="unselectedComponentCards.length > 0"
          class="component-pagination"
          [length]="unselectedComponentCards.length"
          [pageIndex]="availableComponentsPageIndex"
          [pageSize]="availableComponentsPageSize"
          [pageSizeOptions]="availableComponentsPageSizeOptions"
          [showFirstLastButtons]="true"
          (page)="onAvailableComponentsPageChange($event)"
        >
        </mat-paginator>
      </div>

      <div
        class="component-empty-state"
        *ngIf="
          selectedComponentCards.length === 0 &&
          unselectedComponentCards.length === 0
        "
      >
        No components match your search.
      </div>
    </div>

    <div
      class="component-empty-state"
      *ngIf="
        !componentsLoading() &&
        !componentsLoadError() &&
        availableComponents.length === 0
      "
    >
      No components are available.
    </div>

    <app-response-banner
      [success]="successfulSave"
      [successMessage]="successMessage"
      [errorMessage]="errorMessage"
      [invisible]="!showResponseBanner"
    ></app-response-banner>

    <div class="button-box half-width">
      <app-button
        type="button"
        [title]="'Cancel'"
        (click)="cancel()"
      ></app-button>
      <app-button
        [tall]="true"
        [title]="isEditMode ? 'Update Product' : 'Create Product'"
        [disabled]="form.invalid || saving"
      ></app-button>
    </div>
  </form>
</div>
